import { FullCalendarModule } from '@fullcalendar/angular';

import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { NgModule, LOCALE_ID, ApplicationRef, provideAppInitializer, inject, APP_INITIALIZER } from '@angular/core';

import { AppRoutingModule, routes } from './app-routing.module';
import { AppComponent } from './app.component';


import { AppStoreModule } from './app-store.module';
import { ShellModule } from './shell/shell.module';

import { TableModule } from 'primeng/table';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppDialogsModule } from './app-dialogs.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';

import { DialogService} from 'primeng/dynamicdialog';
import { OAuthModule } from 'angular-oauth2-oidc';
import { IsAuthenticatedGuard } from './guards/is-authenticated.guard';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SignalRService } from './common/services/signalr.service';
import { ToastModule } from 'primeng/toast';
import { LipoMessageService } from './common/services/LipoMessageService';

import { TranslateModule } from '@ngx-translate/core';
import { DisableControlDirective } from './common/directives/DisableFormControl';
import { AuthService, CommonCheckService, EnvironmentService } from 'FoxxyLib';
import { NotificationsModule } from './+notifications/notifications.module';
import { DashboardModule } from './+dashboard/dashboard.module';

import { intializeApp } from './app-init';
import { UserTasksModule } from './+userTasks/userTasks.module';
import { ValidationEditorModule } from './+validationEditor/validation-editor.module';






registerLocaleData(localeDe);



@NgModule({ declarations: [

    ],
    exports: [TranslateModule],
    bootstrap: [], imports: [FullCalendarModule,
        ValidationEditorModule,
        UserTasksModule,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        AppStoreModule,
        ShellModule,
        AppDialogsModule,
        // 'whenDisabledForLegacyCode': verhindert den initialen setDisabledState(false)-Aufruf auf jedem
        // ControlValueAccessor. PrimeNG v19 setDisabledState enthält ein setTimeout, das sonst pro Control
        // einen eigenen CD-Zyklus auslöst (Checkbox-Flackern grau/blau in Tabellen, Bug #8318).
        FormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
        ToastModule,
        ReactiveFormsModule,
        MatSnackBarModule,
        DashboardModule,
        NotificationsModule,
        TranslateModule.forRoot(),
        OAuthModule.forRoot({
            resourceServer: { sendAccessToken: true }
        })], providers: [


          provideAppInitializer(() => intializeApp()),
          EnvironmentService,
          AuthService,
        { provide: LOCALE_ID, useValue: 'de-DE' },
        DialogService,
        SignalRService,
        ConfirmationService,
        CommonCheckService,
        IsAuthenticatedGuard,
        MessageService,
        LipoMessageService,
        DisableControlDirective,
        provideHttpClient(withInterceptorsFromDi())
    ] })


export class AppModule {

 }
